export const BASE_URL = 'https://eagledemo.online/theexamtime/api/v1/';
export const Token = 'Bearer 12|wHKa0VMnNISCw9xC60qvkuxDhddv0bHg9jVgU50u';
export const IMGAGE_URL ="https://eagledemo.online/theexamtime/public/storage/"
